import { IonIcon } from "@ionic/react";
import React, { useState } from "react";
import "./callUs.scss";
import ContactUsModal from "../../../components/shared/ContactUsModal/ContactUsModal";
import { contactUsDetailsRequest } from "app/actions/myload/action";
import { CONTACT_DETAILS_NOT_FOUND } from "app/utils/constants";
import { ToastMessage } from "app/utils/ToastMessage";
import { useDispatch } from "react-redux";

export const CallUs: React.FunctionComponent = (props: any) => {
  const [isOpen, onToggle] = useState<boolean>(false);
  const [contactDetails, setContactDetails] = useState<any>(null);
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <ContactUsModal
        isOpen={isOpen}
        onClosed={() => onToggle(false)}
        contactDetails={contactDetails}
      />
      <div className="call-us-link">
        <span onClick={() =>{  
                  const callback = (responseType: string, data: any) => {
                  if (responseType === "success") {
                   onToggle(true)
                   setContactDetails(data?.message)
                  } else {
                   ToastMessage.showWeb(CONTACT_DETAILS_NOT_FOUND);
                 }
                 };
                 const payload = props?.loadDetails?.shipmentId;
                 dispatch(contactUsDetailsRequest({
                   query: payload,
                   callback
                 }))}}>
          <IonIcon src="assets/icon/contact-us.svg" />
          <span>Contact Us</span>
        </span>
      </div>
    </React.Fragment>
  );
};
